import { useContext, useRef, useState } from "react"
import ReactCrop, { centerCrop, makeAspectCrop } from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'

import OneModal from "../../../../../Components/OneModal/OneModal"
import { useDebounceEffect } from "./useDebounceEffect"
import { canvasPreview } from "./CanvasPreview"
import { Button } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { WebSocketContext } from "../../../../../Providers/WebSocket/WebSocketContext"

const centerAspectCrop = (
    mediaWidth,
    mediaHeight,
    aspect
) => {
    return centerCrop(
        makeAspectCrop(
            {
                unit: '%',
                width: 90
            },
            aspect,
            mediaWidth,
            mediaHeight
        ),
        mediaWidth,
        mediaHeight
    )
}

const ativarSalvarImagem = () => {
    const salvarButton = document.getElementById('salvarButton')
    salvarButton.click()
}

const ModalUploadImage = ({ open, setOpen, idUser }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)

    const [loading] = useState(false)
    const [imgSrc, setImgSrc] = useState('')
    const previewCanvasRef = useRef(null)
    const imgRef = useRef(null)
    const [crop, setCrop] = useState()
    const [completedCrop, setCompletedCrop] = useState()
    const [scale] = useState(1)
    const [rotate] = useState(0)
    const [aspect] = useState(1 / 1)

    function onSelectFile(e) {
        if (e.target.files && e.target.files.length > 0) {
            setCrop(undefined) // Makes crop preview update between images.
            const reader = new FileReader()
            reader.addEventListener('load', () =>
                setImgSrc(reader.result?.toString() || '')
            )
            reader.readAsDataURL(e.target.files[0])
        }
    }

    function onImageLoad(e) {
        if (aspect) {
            const { width, height } = e.currentTarget
            setCrop(centerAspectCrop(width, height, aspect))
        }
    }

    useDebounceEffect(
        async () => {
            if (
                completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
            ) {
                // We use canvasPreview as it's much faster than imgPreview.
                canvasPreview(
                    imgRef.current,
                    previewCanvasRef.current,
                    completedCrop,
                    scale,
                    rotate
                )
            }
        },
        100,
        [completedCrop, scale, rotate]
    )

    const salvarImagem = () => {
        addRoute("salvarFotoPerfil", (msg) => {
            setOpen(false)
        })
        const canvas = previewCanvasRef.current
        const inputImage = document.getElementById('inputImage')
        const type = inputImage.files[0].type.split('/')[1]
        const img = canvas.toDataURL(`image/${type}`, 0.5)
        sendWs("salvarFotoPerfil", { id: idUser, imagem: img })
    }

    return (
        <OneModal
            open={open}
            setOpen={setOpen}
            loading={loading}
            titleText="Upload de imagem"
            FooterButtons={FooterButtons}
            width="500px"
            height="850px"
        >
            <div>
                <div style={{ margin: '10px' }}>
                    <input id="inputImage" type="file" accept="image/*" onChange={onSelectFile} />
                </div>
                {!!imgSrc && (
                    <ReactCrop
                        crop={crop}
                        onChange={(_, percentCrop) => setCrop(percentCrop)}
                        onComplete={(c) => setCompletedCrop(c)}
                        aspect={aspect}
                    >
                        <img
                            ref={imgRef}
                            alt="Crop me"
                            src={imgSrc}
                            style={{ transform: `scale(${scale}) rotate(${rotate}deg)` }}
                            onLoad={onImageLoad}
                        />
                    </ReactCrop>
                )}
                {!!completedCrop && (
                    <>
                        <div>
                            <canvas
                                ref={previewCanvasRef}
                                style={{
                                    border: '1px solid black',
                                    objectFit: 'contain',
                                    width: completedCrop.width,
                                    height: completedCrop.height
                                }}
                            />
                        </div>
                    </>
                )}
            </div>
            <div style={{ display: 'none' }}>
                <Button id="salvarButton" color="one_primary" variant="contained" onClick={() => salvarImagem()}>
                    Salvar
                </Button>
            </div>
        </OneModal>
    )
}

export const FooterButtons = () => {
    return (
        <Grid container xs={12} sx={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <Button color="one_primary" variant="contained" onClick={ativarSalvarImagem}>Salvar</Button>
        </Grid>
    )
}

export default ModalUploadImage
